// libraries
import { ColumnsType } from 'antd/lib/table';
import * as antIcon from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

// components
import { SharedTable } from '../../../shared/table';

// locales
import { txt } from '../../../../locales/i18n';

const columns: ColumnsType<object> = [
	{
		title: 'ID',
		dataIndex: 'userId',
		fixed: 'left',
		width: '6rem',
	},
	{
		title: 'Email',
		dataIndex: 'email',
		ellipsis: true,
	},
	{
		title: txt('global.username'),
		dataIndex: 'username',
	},
	{
		title: txt('global.birth year'),
		dataIndex: 'birthYear',
	},
	{
		title: txt('global.municipality'),
		dataIndex: 'municipalityName',
	},
	{
		title: () => <antIcon.MessageOutlined />,
		dataIndex: 'messagesCount',
		width: '5rem',
		render: (value) => value || '',
	},
	{
		title: txt('global.universe'),
		dataIndex: 'universe',
	},
	{
		title: txt('global.created'),
		dataIndex: 'created',
		render: (value) => new Date(value).toLocaleDateString(),
	},
];

export function ChristmasFriendTable(props: any): JSX.Element {
	const history = useHistory();

	return (
		<SharedTable
			rowKey="userId"
			columns={columns}
			loading={props.loading}
			dataSource={props.dataSource}
			onRow={(record: any) => ({
				onClick: () => history.push(`/christmas-friends/${record.christmasFriendId}`),
			})}
		/>
	);
}
